import React from "react";
import { MessageCircle } from "lucide-react";
import { waLink } from "../lib/api";

export default function FloatingWhatsApp() {
  return (
    <a
      href={waLink()}
      target="_blank"
      rel="noreferrer"
      data-testid="floating-whatsapp"
      aria-label="Chat on WhatsApp"
      className="fixed bottom-6 right-6 z-50 group"
    >
      <div className="relative">
        <div className="absolute inset-0 rounded-full bg-[#D4AF37]/30 blur-xl scale-125" />
        <div className="relative w-14 h-14 md:w-16 md:h-16 rounded-full bg-[#25D366] wa-pulse ring-2 ring-[#D4AF37] grid place-items-center shadow-2xl transition-transform group-hover:-translate-y-1">
          <MessageCircle className="w-7 h-7 text-white" strokeWidth={2.4} />
        </div>
      </div>
    </a>
  );
}
